import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class CardSlider extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get slides() {
    return get(this, '_slides', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/CardSlider.model.js